<template>
    <div class="video-item-wrapper">
        <CoverPanel
            :noCoverIcon="noCoverIcon"
            :imageUrl="data.image"
            :operateIcons="operateIcons"
            :viewIcon="viewIcon"
            @viewClick="viewHandler"
            @operatorSelect="editClick"
        />
        <p class="wiki-text">{{ $t("zhiji.wiki.nameTitle") }}: {{ data.namePlatform ? data.namePlatform : data.name }}</p>
        <p class="wiki-text">{{ $t("zhiji.wiki.videoDuration") }}: {{ data.videoDuration }}</p>
        <p class="wiki-text">{{ $t("zhiji.wiki.title") }}: {{ data.title }}</p>
        <p class="wiki-text">{{ $t("zhiji.wiki.views") }}: {{ data.views }}</p>
        <p class="wiki-text">{{ $t("zhiji.wiki.likeNum") }}: {{ data.likeNum }}</p>
        <p class="wiki-text">{{ $t("zhiji.wiki.viewDate") }}: {{ data.viewDate }}</p>
        <TransferIcon class="opr-transfer" @transfer="tranferItem" />
        <DeleteIcon class="opr-delete" @iconClick="deleteItem" />
    </div>
</template>

<script>
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import CoverPanel from "@/views/zhiji/components/questionEdit/answers/widgets/CoverPanel";

export default {
    name: "VideoItem",
    props: ["data"],
    components: {
        TransferIcon,
        DeleteIcon,
        CoverPanel
    },
    data() {
        return {
            viewIcon: {
                position: "-60px -85px"
            }
        };
    },
    computed: {
        noCoverIcon() {
            return {
                position: "-172px -50px",
                label: this.$t("zhiji.answer.addVideo")
            };
        },
        operateIcons() {
            return [
                {
                    type: "edit",
                    position: "-296px 1px",
                    name: this.$t("zhiji.materialLibrary.editVideo")
                }
            ];
        }
    },
    watch: {},
    methods: {
        viewHandler() {
            const { videoUrl } = this.data;
            videoUrl &&
                this.$store.dispatch("zhiji/showModal", {
                    type: "VideoViewModal",
                    data: {
                        url: videoUrl
                    }
                });
        },
        editClick() {
            this.$emit("editClick", this.data);
        },
        tranferItem(event) {
            this.zhiji.dragStart(event, "block-item-wrap", "h", newIdx => {
                this.$emit("tranferClick", {
                    item: this.data,
                    newIdx
                });
            });
        },
        deleteItem() {
            this.$emit("deleteClick", this.data);
        }
    }
};
</script>

<style lang="scss" scoped>
.video-item-wrapper {
    position: relative;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 12px;
    flex-shrink: 0;
    width: 200px;

    .opr-transfer {
        display: none;
        top: -21px;
        left: -2px;
        z-index: 1;
        position: absolute;
    }

    .opr-delete {
        display: none;
        right: -9px;
        top: -9px;
        z-index: 1;
        position: absolute;
    }

    &:hover {
        .opr-transfer {
            display: inline-flex;
        }

        .opr-delete {
            display: inline-block;
        }
    }
    .wiki-text {
        padding: 0 8px;
        box-sizing: border-box;
        height: 32px;
        line-height: 32px;
        border-top: 1px solid #d8e4f0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
}
</style>
